import Icon from '@components/icon';
import IconWithActive from '@components/icon-with-active';
import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { NotificationIcon } from 'components/NotificationIcon';
import { staticTabsId } from 'constants/ui';
import { useStore } from 'hooks/useStore';
import { tabIds } from 'store/UIStore/UIStore';

import { Tab } from '../Tab';
import { TabsProps } from '../Tabs';
import tabsCss from '../Tabs.module.css';

import css from './Static.module.css';

interface StatisProps extends TabsProps {
  isSticky: boolean;
}

const Static = (props: StatisProps) => {
  const { subscriptions, favorites } = useStore();

  const { tabsData, activeTab, onChange, isPinned, onPin } = props;
  const { hasLoadsUpdates } = subscriptions;

  const mainTabs = tabsData.slice(0, -1);
  const lastTab = tabsData[tabsData.length - 1];

  const critialNotification = subscriptions?.criticalNotifications && subscriptions?.criticalNotifications[0];
  const warningNotification = subscriptions.warningNotifications && subscriptions?.warningNotifications[0];

  return (
    <div className={css.container} id={staticTabsId}>
      <div className={css.mainTabs}>
        {isPinned && (
          <IconWithActive
            activeIcon={<Icon color="var(--white)" height={14} name="ic_pin" width={14} />}
            className={cn(tabsCss.pinButton, tabsCss.pinButton_static)}
            defaultIcon={<Icon color="var(--dark-gray)" height={14} name="ic_pin" width={14} />}
            onClick={onPin}
          />
        )}

        {mainTabs.map(tab => (
          <Tab key={tab.id} isActive={tab.id === activeTab} tab={tab} onChange={onChange}>
            {tab.label}
            {hasLoadsUpdates && tab.id === tabIds.savedFilters && <span className={css.totalCounter}></span>}

            {tab.id === tabIds.favorites && Boolean(favorites.count) && ` ${favorites.count}`}

            {critialNotification && tab.id === tabIds.savedFilters && (
              <NotificationIcon className={css.notificationIcon} notification={critialNotification} />
            )}

            {warningNotification && tab.id === tabIds.savedFilters && !critialNotification && (
              <NotificationIcon className={css.notificationIcon} notification={warningNotification} />
            )}
          </Tab>
        ))}
      </div>

      <Tab isSpecial isActive={lastTab.id === activeTab} tab={lastTab} tooltipPosition="left" onChange={props.onChange}>
        {lastTab.label}
      </Tab>
    </div>
  );
};

const connected = observer(Static);

export { connected as Static };
